<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_4702_3673"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4702_3673)">
      <path
        d="M4.66671 11.3333L1.33337 8L4.66671 4.66667L5.60004 5.60001L3.88337 7.33334H12.1167L10.4 5.60001L11.3334 4.66667L14.6667 8L11.3334 11.3333L10.4 10.4L12.1167 8.66667H3.88337L5.60004 10.4L4.66671 11.3333Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<script>
import { Vue } from "vue-class-component";

export default class IcArrowRange extends Vue {}
</script>
